module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: ['flexRow', _vm.loggedIn ? '' : 'guest']
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Block32")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/day"
    }
  }, [_vm._v("Day")]), _vm._v(" "), (!_vm.isMobile()) ? _c('router-link', {
    attrs: {
      "to": "/week"
    }
  }, [_vm._v("Week")]) : _vm._e(), _vm._v(" "), (!_vm.isMobile()) ? _c('router-link', {
    attrs: {
      "to": "/month"
    }
  }, [_vm._v("Month")]) : _vm._e(), _vm._v(" "), (_vm.isBetaUser) ? _c('router-link', {
    attrs: {
      "to": "/realtime"
    }
  }, [_vm._v("Realtime")]) : _vm._e(), _vm._v(" "), (_vm.isBetaUser) ? _c('router-link', {
    attrs: {
      "to": "/line"
    }
  }, [_vm._v("Line")]) : _vm._e(), _vm._v(" "), (!_vm.isMobile() && _vm.isBetaUser) ? _c('router-link', {
    attrs: {
      "to": "/trend"
    }
  }, [_vm._v("Trend")]) : _vm._e(), _vm._v(" "), (!_vm.isMobile() && _vm.isBetaUser) ? _c('router-link', {
    attrs: {
      "to": "/changes"
    }
  }, [_vm._v("Changelog")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRow"
  }, [_c('div', {
    staticClass: "helpLink"
  }, [(!_vm.isMobile() && _vm.isBetaUser) ? _c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help")]) : _vm._e()], 1), _vm._v(" "), _c('user-profile-link')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0092384!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/AppHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b0092384!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/AppHeader.vue
// module chunks = 0